module.exports = __webpack_public_path__ + "img/notfound.bdaff218.png";